// Minimal JWT helpers — decode only, the backend remains the authority on validity.

function decodePayload(token) {
  try {
    const part = String(token).split('.')[1];
    if (!part) return null;
    const base64 = part.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch {
    return null;
  }
}

// Returns true only when the token carries a numeric `exp` in the past.
// Opaque/malformed tokens are treated as "not known to be expired".
export function isTokenExpired(token, now = Date.now()) {
  const exp = decodePayload(token)?.exp;
  return typeof exp === 'number' && exp * 1000 <= now;
}
